import RickImg from "../assets/images/partner-images-2024-07-31/compressed-images/rick-davidson.webp";
import ShaunImg from "../assets/images/partner-images-2024-07-31/compressed-images/shaun-kentwell.webp";
import DomImg from "../assets/images/partner-images-2024-07-31/compressed-images/dom-wallace-facing-center.webp";
import RyanImg from "../assets/images/partner-images-2024-07-31/compressed-images/ryan-kehl.webp";
import KatieImg from "../assets/images/partner-images-2024-07-31/compressed-images/katie-archdekin-glasses.webp";
import JasonImg from "../assets/images/partner-images-2024-07-31/compressed-images/jason-carson-biggest-smile.webp";
import RobImg from "../assets/images/partner-images-2024-07-31/compressed-images/rob-nash.webp";
import LinedInIcon from "../assets/images/svg/linkedin.svg";
import AdrienImage from "../assets/images/partner-images-2024-07-31/compressed-images/adrien-maurer-smile.webp";
import VincentImg from "../assets/images/partner-images-2024-07-31/Vincent-Chan.jpg";
import JibranImg from "../assets/images/partner-images-2024-07-31/Jibran-Imtiaz.jpg";
import tomImg from "../assets/images/tom_pickles.jpg";
import erinImg from "../assets/images/erin_helcl.png";
import scottImg from "../assets/images/scott_ivory.png";

// Icons
// import {
//   TrophyIcon,
//   UserGroupIcon,
//   CogIcon,
//   EyeIcon,
//   ArrowTrendingUpIcon,
//   PuzzlePieceIcon,
//   HeartIcon,
// } from "@heroicons/react/24/outline";

const values = [
  {
    label: "Deliver What Matters",
    description:
      "We measure success by the lasting value we create for our client, our teammates, and our community.",
  },
  {
    label: "Build With Integrity",
    description:
      "We do what's right, even when it's hard. We build trust through action, defend our principles, and always follow through.",
  },
  {
    label: "Impact Over Ego",
    description:
      "We own what we know, stay curious about what we don't, follow the facts, and let our results do the talking.",
  },
  {
    label: "Lift As We Climb",
    description:
      "We learn out loud, share what we know, and support each other as we grow individually and as a team.",
  },
  {
    label: "Enjoy The Journey",
    description:
      "We work hard, laugh often, celebrate the wins, and show gratitude for one another along the way.",
  },
];

const founders = [
  {
    name: "Rick Davidson",
    position: "CEO",
    img: RickImg,
    linkedIn: "https://www.linkedin.com/in/ricktdavidson/",
    questions: [
      {
        A: "I'm an IT executive with 25 years of experience building exceptional teams and transformational technology solutions. I spent half of my career honing my leadership skills, so I could build a people-first company. I believe in a culture of collaboration, determination and, perhaps most importantly, respect for each other and for our clients.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "RAVLrs are enthusiastic. It's all about getting out of your comfort zone to grow as a professional and as a person. It's also about having fun. Life is short, enjoy the ride!",
      },
    ],
  },
  {
    name: "Shaun Kentwell",
    position: "Client Partner, Head of Delivery",
    img: ShaunImg,
    linkedIn: "https://www.linkedin.com/in/shaunkentwell/",
    questions: [
      {
        A: "I'm a technologist and strategist overseeing operations at RAVL. With nearly 20 years of leadership experience, I'm passionate about connecting businesses with the right tech to deliver extraordinary programs.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "We launched RAVL to disrupt the technology services industry, and that's exactly what we're doing, with a best-in-class team, with a culture of excellence and mutual support. RAVLrs thrive on new challenges and the pursuit of mastery (plus the occasional doughnut).",
      },
    ],
  },
  {
    name: "Dom Wallace",
    position: "CTO",
    img: DomImg,
    linkedIn: "https://www.linkedin.com/in/dom-wallace/",
    questions: [
      {
        A: "I'm a technologist and architect with over 15 years of experience transforming how financial businesses build and run their software. I love solving complex problems alongside talented people and creating a RAVL work culture that makes me proud.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "We're passionate about technology, love learning, and are excited to solve tough problems. RAVLrs question assumptions and challenge the latest technology trends.",
      },
    ],
  },
  {
    name: "Ryan Kehl",
    position: "Head of Build",
    img: RyanImg,
    linkedIn: "https://www.linkedin.com/in/ryanjkehl/",
    questions: [
      {
        A: "After more than 15 years developing products, leading teams, and driving transformative enterprise projects, I've reached a point in my career where I need my work to have purpose. I lead people and culture at RAVL, and I want everyone inside and outside the company to benefit from technology as much as I have.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "A RAVLr understands that tech is more than the code you write or the certifications you aspire to. We pursue growth for ourselves and others and deliver exceptional client experiences.",
      },
    ],
  },
  {
    name: "Katie Archdekin",
    position: "Head of Advisory Accelerators",
    img: KatieImg,
    linkedIn: "https://www.linkedin.com/in/katiearchdekin/",
    questions: [
      {
        A: "I'm an Advisor, leader, and mentor with over 20 years' experience in strategy and general management. Before joining the firm, I worked with the other RAVL partners. I knew this team had the smarts, drive, and integrity to create something extraordinary.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "Being a RAVLr feels like being part of a large family, with shared moments of joy, laughter, hard work, and the occasional squabble. We feel safe debating our ideas because we've cultivated deep trust and respect for one another.",
      },
    ],
  },
  {
    name: "Jason Carson",
    position: "Senior Principal, Build",
    img: JasonImg,
    linkedIn: "https://www.linkedin.com/in/jasonfcarson/",
    questions: [
      {
        A: "After nearly 20 years in operations, software development and cloud consulting, I joined RAVL to help people from diverse backgrounds excel in tech. I love watching career changers and self-taught tech enthusiasts overcome their barriers to success.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "At RAVL, accountability, high expectations and unwavering support are the norm. We embrace our shared humanity while navigating the ever-evolving world of tech.",
      },
    ],
  },
  {
    name: "Rob Nash",
    position: "Client Partner, Head of Sales & Partnerships",
    img: RobImg,
    linkedIn: "https://www.linkedin.com/in/rob-nash/",
    questions: [
      {
        A: "With nearly two decades of experience in financial services with top banks and consulting firms, including roles in business management, operations, and technology, I've come to value the innovation and improved outcomes that partnerships bring. I joined RAVL because of their high-performance, fun culture and dedication to tackling complex challenges and creating sustainable solutions.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "Being a RAVLr is a dynamic mix of speed and initiative, being curious, supporting each other, and achieving meaningful outcomes for clients.",
      },
    ],
  },
  {
    name: "Adrian Maurer",
    position: "Senior Principal, Build",
    img: AdrienImage,
    linkedIn: "https://ca.linkedin.com/in/adrianmaurer",
    questions: [
      {
        A: "With over 15 years of experience at the intersection of startups and enterprise technology—building products, scaling teams, and modernizing complex systems—I’ve developed a passion for creating solutions that drive meaningful impact. At RAVL, my role blends strategic oversight with hands-on delivery and mentorship: whether guiding AI adoption, advocating for pragmatic solutions, or fostering environments where junior developers evolve into confident leaders.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "RAVLrs thrive on the balance between rigor and reinvention. We approach every challenge with the humility to question our assumptions and the courage to defend our principles. Here, expertise isn’t static—it’s a commitment to lifelong learning, shared openly, and applied with intentionality.",
      },
    ],
  },
  {
    name: "Vincent Chan",
    position: "Head of Operations",
    img: VincentImg,
    linkedIn: "https://www.linkedin.com/in/vincechan/",
    questions: [
      {
        A: "I turn strategy into execution at RAVL, working with our leadership team to set direction, build operating discipline, and drive the business forward. I move between the big picture and the details, turning complexity into clear, executable work. I bring clarity to what matters and put structure behind how teams operate so priorities move and outcomes follow. I’m counted on to ask hard questions, challenge assumptions, and keep us honest about what’s working and what’s not. I believe most problems are simpler than they look once you narrow in on what actually matters.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "RAVLrs own outcomes that matter, end to end. We don’t stop at ideas or effort. We follow through, push through obstacles, and take responsibility for what gets delivered. When something isn’t working, we ask hard questions, sit with the hard truths, and act.",
      },
    ],
  },
  {
    name: "Jibran Imtiaz",
    position: "Head of Advisory",
    img: JibranImg,
    linkedIn: "https://www.linkedin.com/in/jibranimtiaz/",
    questions: [
      {
        A: "I am a strategist and advisor with roots in technology and 15+ years of experience advising North American FIs on strategy & technology, as well as leading product, analytics, and innovation functions. I love building great teams, solving tough problems, and making sure we are all growing and having fun along the way.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "Being a RAVLr is being part of an authentic and honest environment, and a culture that is dynamic and introspective. It is about taking accountability for the client impact we create, preserving what we have built, and actively shaping what it can become.",
      },
    ],
  },
  {
    name: "Erin Helcl",
    position: "Head of Product & Experience",
    img: erinImg,
    linkedIn: "https://www.linkedin.com/in/erin-helcl/",
    questions: [
      {
        A: "I’m a product and experience leader with 25 years of experience helping organizations navigate transformation, improve customer experiences, and deliver meaningful business outcomes. My focus sits at the intersection of product, experience, strategy, and AI, helping teams simplify complexity, align around outcomes, and build products and services that are both human-centered and commercially effective. I believe the best innovation happens when strong strategy, technology, and empowered teams come together to solve real problems in practical ways.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "Being a RAVLr means being curious, adaptable, and willing to challenge conventional thinking. It’s a fast-moving environment focused on solving real business problems, building meaningful client partnerships, and helping organizations prepare for what’s next. What stands out most to me is the combination of ambition, collaboration, and a genuine willingness to experiment, learn, evolve, and laugh together along the way.",
      },
    ],
  },
  {
    name: "Scott Ivory",
    position: "Senior Principal, Build",
    img: scottImg,
    linkedIn: "https://www.linkedin.com/in/scottivory/",
    questions: [
      {
        A: "I’ve spent 25 years in technology, but what has kept me in the work is not just the technology itself. It’s the people, the teams, and the moments where a group of smart, committed people turn a hard problem into something real. My background spans cloud, DevOps, security, software delivery, and AI, with much of that work focused on complex, regulated organizations. At RAVL, I’m excited to help shape a company that takes delivery seriously, invests in talent,and creates the kind of environment where people can do the best work of their careers.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "Being a RAVLr means being surrounded by people who care deeply about the work and about each other. There is a strong bias toward action, but also a real commitment to learning, collaboration, and doing things the right way. What stands out to me is the energy: people are ambitious, generous with their knowledge, and genuinely invested in helping clients and teammates succeed.",
      },
    ],
  },
  {
    name: "Tom Pickles",
    position: "Senior Principal, Advisory",
    img: tomImg,
    linkedIn: "https://www.linkedin.com/in/tom-pickles-38424726/",
    questions: [
      {
        A: "I am a strategist at heart, with 15+ years of experience across management consulting and leadership roles in strategy, analytics, and product at a Canadian FI. I am energized by exploring how to apply technology and innovation in pragmatic ways to drive meaningful business outcomes for our clients.",
      },
      {
        Q: "What is it like to be a RAVLr?",
        A: "RAVLrs are curious, humble, and not afraid to challenge each other to get to the best result we can. We bring high standards to the work we produce and don't take ourselves too seriously while we do it.",
      },
    ],
  },
];

const About = () => {
  return (
    <div className="container mx-auto">
      {/* Values Section */}
      <section className="flex flex-col">
        <div className="text-center px-4 pt-16 pb-8">
          <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl">
            Our <span className="text-purple-700">Team</span>. Our
            <span className="text-purple-700"> Values</span>.
          </h1>
        </div>
        <div className="rounded-2xl mx-4 md:mx-8 p-4 md:p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {values.map((item) => (
              <div
                key={item.label}
                className="bg-[#1E1152] rounded-xl p-6 flex flex-col gap-3"
              >
                <p className="font-bold text-xl text-white leading-snug min-h-[3.5rem]">
                  {item.label}
                </p>
                <p className="text-base text-gray-300 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="p-4 md:p-8">
        <div className="flex flex-col items-center gap-6 md:gap-11 xl:px-64">
          <h2 className="text-4xl font-bold text-gray-900 sm:text-5xl mb-6 text-center">
            <span className="text-purple-700">Our</span> Story
          </h2>
          <div className="card lg:p-6 flex flex-col gap-4 lg:gap-6 text-gray-600 text-base sm:text-xl max-w-3xl">
            <div className="flex flex-col gap-4 lg:gap-6 text-center sm:text-left">
              <p className="text-base">
                {" "}
                <span className="text-purple-700">RAVL</span>
                <br /> <span className="font-bold">origin:</span> ravel,
                /ˈrav(ə)l/
                <br /> <span className="font-bold">definition:</span> verb—to
                disentangle or resolve, make simpler
                <br />
              </p>
              <hr className="w-1/4 border-black" />
              <p className="text-purple-700 font-bold">About RAVL</p>
              <p className="text-base">
                <span className=" text-purple-700 font-bold"> RAVL</span> is
                boutique technology advisory and engineering firm focused on the
                financial services industry. Everything we do is focused on
                helping our clients realize measurable ROI on their technology
                investments.
              </p>
              <p className="text-base">
                Our name means “to disentangle,” “to make simpler” and that’s
                just what we do—deliver elegant solutions to complex financial
                services problems.
              </p>
            </div>

            <div className="flex flex-col gap-4 lg:gap-6">
              <p className="text-base">
                At RAVL, we involve advisors and engineers on every engagement.
                Whether we’re modernizing applications, developing AI
                strategies, transforming DevSecOps or anything else, our{" "}
                <span className="font-bold">
                  {" "}
                  engineers ensure we only propose actionable strategies
                </span>
                , and{" "}
                <span className="font-bold">
                  {" "}
                  our advisors make certain we only design, build and deliver
                  technology that solves your actual business problems.{" "}
                </span>
              </p>
            </div>

            <div className="flex flex-col gap-4 lg:gap-6">
              <p className="text-purple-700 font-bold">How are we different?</p>
              <ol className="list-decimal pl-5 text-base">
                <li>
                  We don’t sell inputs (bodies), we take accountability for
                  delivering business/technology{" "}
                  <span className="font-bold italic">outcomes</span>
                </li>
                <li>
                  We believe a strategy is worthless if it can’t be implemented.
                  All our advisory engagements include engineers and architects
                  to ensure our recommendations can truly, and successfully, be
                  implemented.
                </li>
                <li>
                  Our biggest differentiator is that we leave our clients with
                  mentored, skilled employees, able to continue the journey and
                  support their RAVL-built business/technology assets for years
                  to come.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="text-center p-4 md:p-8">
        <div className="flex flex-col items-center gap-6 md:gap-11 xl:px-64">
          <h2 className="text-4xl font-bold text-gray-900 sm:text-5xl">
            What Is <span className=" text-purple-700">RAVL</span>?
          </h2>
          <div className="card lg:p-6 flex flex-col gap-4 lg:gap-6 text-gray-600 text-base sm:text-xl max-w-3xl text-center sm:text-left">
            <div className="flex flex-col gap-4 lg:gap-6">
              <div className="text-xl text-purple-700 font-bold gap-4">
                How we started{" "}
              </div>
              <p className="text-base">
                In 2022, our founding partners gathered around our CEO (Rick's)
                ping-pong table, eager to discuss how we could fix the gaps in
                technology consulting and engineering. We were all successful in
                our careers, working with Canada's leading financial
                institutions and the world's best advisory firms.{" "}
              </p>
              <p className="text-base">
                <strong>
                  We loved our work, but we didn't love it when clients weren't{" "}
                  <em>realizing the full value of their investments.</em>
                </strong>
              </p>
              <p className="text-base">
                We knew there was a better way, so we built it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="p-4 md:p-8">
        <div className="grid grid-cols-1 gap-6 md:gap-11 xl:px-32">
          <div className="flex flex-col items-center gap-4 md:gap-8 text-center max-w-3xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 sm:text-5xl">
              Meet Our <span className="text-purple-700">Leadership</span> Team
            </h2>
            <p className="text-gray-600 sm:text-xl">
              Our leadership team has worked together for over a decade. The
              genesis of RAVL was simple: create an environment where great
              technologists work together to build exceptional technology and
              support each other in our quest towards excellence.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 lg:gap-8">
            {founders.map((founder, index) => (
              <div
                key={founder.name}
                className={`card flex flex-col items-center justify-between text-sm leading-6 w-full md:w-5/12 md:p-8 ${
                  index === founders.length - 1
                    ? "col-span-2 md:col-span-1"
                    : ""
                }`}
              >
                <div className="items-center justify-center">
                  <img
                    className="rounded-lg object-cover w-full h-full"
                    src={founder.img}
                    alt={founder.name}
                  />
                </div>

                <div className="flex flex-col h-full pt-4 lg:pt-8">
                  <div className="flex flex-row justify-between mb-2 md:mb-4">
                    <div>
                      <h3 className="font-bold text-3xl text-gray-600">
                        {founder.name}
                      </h3>
                      <p className="font-bold text-lg text-purple-700">
                        {founder.position}
                      </p>
                    </div>
                    <a
                      target="_blank"
                      rel="noreferrer noopener"
                      href={founder.linkedIn}
                      aria-label="LinkedIn"
                    >
                      <img
                        src={LinedInIcon}
                        alt="LinkedIn Logo"
                        className="h-8 w-8"
                        aria-hidden="true"
                      />
                    </a>
                  </div>
                  <div className="grid grid-cols-1 gap-4 rounded-lg">
                    {founder.questions.map((question, idx) => (
                      <div key={idx} className="rounded-lg">
                        <h4 className="font-bold text-lg text-gray-600">
                          {question.Q}
                        </h4>
                        <p className="text-sm text-gray-600">{question.A}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Future All RAVLrs Section */}

      {/* Locations */}
      <section className="flex flex-col justify-center p-4 md:p-8">
        <h2 className="text-5xl text-center font-bold text-purple-700 mb-8">
          Locations.
        </h2>

        <div className="flex flex-col sm:flex-row justify-center gap-4 lg:ml-24">
          <div className="px-6 text-gray-600 sm:text-xl sm:w-1/3 max-w-xs">
            <h3 className="text-xl font-bold text-purple-700 border-b-2 border-purple-600 lg:w-3/4 md:w-full sm:w-full pl-2 mb-2">
              Canada
            </h3>
            <div className="px-2">
              <p>1 Toronto Street</p>
              <p>Suite 216</p>
              <p>Toronto</p>
              <p>Ontario M5C 3B2</p>
            </div>
          </div>

          <div className="px-6 text-gray-600 sm:text-xl sm:w-1/3 max-w-xs">
            <h3 className="text-xl font-bold text-purple-700 border-b-2 border-purple-600 lg:w-3/4 md:w-full sm:w-full pl-2 mb-2">
              United States
            </h3>
            <div className="px-2">
              <p>600 5th Ave</p>
              <p>2nd Floor</p>
              <p>New York</p>
              <p>NY 10020</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default About;
